import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-10">
            <p className="text-foreground-500 font-label text-xs tracking-wider uppercase mb-2">
              爆料分类
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              精选分类
              <br />
              <span className="text-foreground-400">快速找到你想要的瓜</span>
            </h2>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group block bg-background-100 rounded-lg p-6 transition-all duration-300 hover:bg-accent-50"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-50 mb-5 group-hover:bg-accent-100 transition-colors duration-200">
                  <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-accent-700 transition-colors duration-200`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                  {cat.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}